import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const PricingSection = styled.div`
  flex: 1;
  min-width: 300px;
  margin: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Title = styled.h2`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
`;

const PriceList = styled.ul`
  list-style: none;
  padding: 0;
`;

const PriceItem = styled.li`
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  &:last-child {
    border-bottom: none;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

const PricingContainer = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/Login');
  };

  return (
    <div>
      <Container style={{
        marginTop: "120px",
      }}>
        <PricingSection>
          <Title>Standalone</Title>
          <PriceList>
            <PriceItem>пакет 1 контрагент $15,00\міс</PriceItem>
            <PriceItem>пакет до 3 контрагентів $30,00\міс</PriceItem>
            <PriceItem>пакет до 6 контрагентів $50,00\міс</PriceItem>
            <PriceItem>пакет до 10 контрагентів $70,00\міс</PriceItem>
          </PriceList>
          <ButtonContainer>
           
          </ButtonContainer>
        </PricingSection>

        <PricingSection>
          <Title>Chain</Title>
          <PriceList>
            <PriceItem>пакет до 10 контрагентів $70,00\міс</PriceItem>
            <PriceItem>пакет до 15 контрагентів $100,00\міс</PriceItem>
            <PriceItem>пакет до 20 контрагентів $120,00\міс</PriceItem>
          </PriceList>
          <ButtonContainer>
            
          </ButtonContainer>
        </PricingSection>
      </Container>
      <Container>
      <PricingSection>
      <button className="download-button-g" style={{marginRight: '10px'}}>Подати заявку</button>
      <button className="download-button-f" onClick={handleLoginRedirect}>Повернутися на сторінку входу</button>
      </PricingSection>
      </Container>
    </div>
  );
};

export default PricingContainer;